var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React, { createContext, useContext, useMemo, useState } from 'react';
import { event } from '../EventBridge';
var initialContext = {
    wishList: [],
    toggleSku: function () { },
};
var WishListContext = createContext(initialContext);
// Hook for Components - u can use the wishlist by including this
export var useWishList = function () { return useContext(WishListContext); };
// Provider - Wrap this to use useWishList
var WishListProvider = function (_a) {
    var children = _a.children;
    var _b = useState([]), wishList = _b[0], setWishList = _b[1];
    // Get WishList from Intershop
    useMemo(function () {
        if (typeof window !== 'undefined') {
            // Event listerner for first trigger. Returnes WishList as { [sku]: 0/1 }
            event.unique('wishlistReady', function (data) {
                var is7WishList = data;
                setWishList(Object.keys(is7WishList).filter(function (sku) { return Boolean(is7WishList[sku]); }));
            });
        }
    }, []);
    var toggleSku = function (sku) {
        var additionalWishlistProperty = {};
        if (typeof window !== 'undefined') {
            additionalWishlistProperty = __assign({}, ((globalThis === null || globalThis === void 0 ? void 0 : globalThis.emma_pagegroup) === 'KS_Produktliste' ? { mba: true } : {}));
        }
        // Tell Intershop to toggle this sku
        event.trigger('toggleWishlist', __assign({ sku: sku }, additionalWishlistProperty));
        // Remove / Add Sku to wishlist in context
        if (wishList.includes(sku)) {
            setWishList(wishList.filter(function (item) { return item !== sku; }));
        }
        else {
            setWishList(__spreadArrays(wishList, [sku]));
        }
    };
    return (React.createElement(WishListContext.Provider, { value: {
            toggleSku: toggleSku,
            wishList: wishList,
        } }, children));
};
export default WishListProvider;
//# sourceMappingURL=index.js.map